export interface HttpParams {
  [name: string]: string;
}
